import type { CsvEntityConfig, BulkUploadRowError } from '../types';

export interface ValidationResult {
  validRows: Record<string, any>[];
  errors: BulkUploadRowError[];
  hasErrors: boolean;
}

export function validateCsvRows(
  rows: Record<string, string>[],
  config: CsvEntityConfig
): ValidationResult {
  const validRows: Record<string, any>[] = [];
  const errors: BulkUploadRowError[] = [];

  for (let i = 0; i < rows.length; i++) {
    const rowNum = i + 2;
    const result = config.validationSchema.safeParse(rows[i]);

    if (result.success) {
      validRows.push(result.data);
    } else {
      result.error.errors.forEach(err => {
        errors.push({
          row: rowNum,
          field: err.path.join('.'),
          message: err.message,
        });
      });
    }
  }

  return { validRows, errors, hasErrors: errors.length > 0 };
}



